import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import withReactContent from 'sweetalert2-react-content';
import swal from 'sweetalert2';
import { toast } from 'react-toastify';

import { getHeaders } from '../../../../helpers/getHeaders';
import axios from '../../../../axios-instance';
import NewLoader from '../../../../components/NewLoader/NewLoader';

import './PromoterEmail.sass';

const INIT_DATA = {
  apiKey: '',
  email: '',
  name: '',
}

const MySwal = withReactContent(swal);

export const PromoterEmail = ({
  token,
}) => {
  const [isDataLoading, setDataLoading] = useState(true);
  const [emailInfo, setEmailInfo] = useState(null);
  const [isApiKeyVerified, setApiKeyVerified] = useState(false);
  const [isEmailSent, setEmailSent] = useState(false);

  const getEmailInfo = async () => {
    setDataLoading(true);

    return axios
      .get(`/PromoterSendGridInfo`, { headers: getHeaders(token) })
      .then((response) => {
        if (response.data.isSuccess) {
          if (response.data.result) {
            setEmailInfo(response.data.result);
            setApiKeyVerified(true);
            setEmailSent(true);
          }

          return response.data.result;
        }
        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error('Email info not received');
      })
      .finally(() => {
        setDataLoading(false);
      });
  }

  const openEmailSetting = () => {
    setEmailInfo(INIT_DATA);
  }

  const onChangeEmailInfo = (key, value) => {
    setEmailInfo(prev => ({
      ...prev,
      [key]: value,
    }));
  }

  const verifyApiKey = async () => {
    setDataLoading(true);

    return axios
      .get(`/PromoterSendGridInfo/ApiKeyValidation/${emailInfo.apiKey}`, { headers: getHeaders(token) })
      .then(async (response) => {
        if (response.data.isSuccess) {
          if (!response.data.result) {
            toast.error('SendGrid API key not verified');
          }

          setApiKeyVerified(response.data.result);

          return response.data.result;
        }
        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setDataLoading(false);
      });
  }

  const saveEmailInfo = async () => {
    try {
      const res = await axios.put(
        `/PromoterSendGridInfo`,
        emailInfo,
        {headers: getHeaders(token)}
      );

      setEmailSent(true);

      if (!res.data) {
        throw new Error(res.data.errorMessage);
      }
    } catch (error) {
      const message = `SendGrid info not saved. ${error}` || 'SendGrid info not saved'
      toast.error(message);
    }
  }

  const verifyEmail = async () => {
    return axios
      .post(
        `/PromoterSendGridInfo/SendVerificationEmail/${emailInfo.email}`,
        emailInfo.email,
        { headers: getHeaders(token) })
      .then(async (response) => {
        if (response.data.isSuccess) {
          if (!response.data.result) {
            toast.error('SendGrid API key not verified');
          } else {
            MySwal.fire({
            title: "Email is sent",
            text: "Verification link is sent on input email",
          });
          }

          return response.data.result;
        }
        // throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error('Something went wrong');
      })
  }

  const handleConfirmInfo = async () => {
    setDataLoading(true);
    try {
      if (emailInfo.isVerified) {
        saveEmailInfo();
      } else {
        Promise.all([saveEmailInfo(), verifyEmail()]);
      }
    } finally {
      setDataLoading(false);
    }
  }

  const deleteEmailInfo = async () => {
    setDataLoading(true);

    try {
      const { data } = await axios.delete(
        `/PromoterSendGridInfo`,
        {headers: getHeaders(token)}
      );

      toast.success('Personal mailbox domain deleted');
      setEmailInfo(null);
      setApiKeyVerified(false);
      setEmailSent(false);
    } catch (error) {
      const message = 'Personal mailbox domain not deleted'
      toast.error(message);
    } finally {
      setDataLoading(false);
    }
  }

  useEffect(() => {
    getEmailInfo();
  }, []);

  if (isDataLoading) {
    return <NewLoader />;
  }

  return (
    <section className="promoter-email">
      {emailInfo && !isEmailSent && (
        <div>
          {isApiKeyVerified ? (
            <div>
              <div className="add-event__block">
                <div className="promoter-email__label">
                  <label>Your API key</label>
                  <div className={`status-label status-label--verified`}>
                    Verified
                  </div>
                </div>
                <span className="add-event__block__count">
                  {emailInfo.apiKey}
                </span>
              </div>

              <div className="add-event__block">
                <label className="promoter-email__label">Email</label>
                <input
                  type="email"
                  name="email"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter email"
                  value={emailInfo.email}
                  onChange={(e) => onChangeEmailInfo('email', e.target.value)}
                />
              </div>

              <div className="add-event__block">
                <label className="promoter-email__label">Name</label>
                <input
                  type="text"
                  name="name"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter name"
                  value={emailInfo.name}
                  onChange={(e) => onChangeEmailInfo('name', e.target.value)}
                />
              </div>
            </div>
          ) : (
            <div className="add-event__block">
              <label className="promoter-email__label">SendGrid API key</label>
              <input
                type="text"
                name="name"
                minLength="3"
                maxLength="500"
                placeholder="Enter SendGrid API key"
                value={emailInfo.apiKey}
                onChange={(e) => onChangeEmailInfo('apiKey', e.target.value)}
              />
            </div>
          )}
        </div>
      )}

      {emailInfo && isEmailSent && (
        <div>
          <div className="add-event__block">
            <div className="promoter-email__label">
              <label>Your API key</label>
              <div className={`status-label status-label--verified`}>
                Verified
              </div>
            </div>
            <span className="add-event__block">
              {emailInfo.apiKey}
            </span>
          </div>

          <div className="add-event__block">
            <label className="promoter-email__label">Email</label>
            <span className="add-event__block">
              {emailInfo.email}
            </span>
          </div>

          <div className="add-event__block">
            <label className="promoter-email__label">Name</label>
            <input
              type="text"
              name="name"
              minLength="3"
              maxLength="500"
              placeholder="Enter name"
              value={emailInfo.name}
              onChange={(e) => onChangeEmailInfo('name', e.target.value)}
            />
          </div>
        </div>
      )}

      {!emailInfo && (
        <div className="promoter-email__default-message">
          Click <strong>"BTN"</strong> to link your mailbox domain.
        </div>
      )}

      <div className="promoter-email__actions">
        {!emailInfo && (
          <button
            type='button'
            className='btn-primary promoter-email__btn'
            onClick={openEmailSetting}
          >
            Use personal mailbox domain
          </button>
        )}

        {emailInfo && !isApiKeyVerified && (
          <button
            type='button'
            className='btn-primary promoter-email__btn'
            onClick={verifyApiKey}
          >
            Verify
          </button>
        )}

        {(emailInfo && isApiKeyVerified) && (
          <>
            <button
              type='button'
              className='btn-primary promoter-email__btn'
              onClick={deleteEmailInfo}
            >
              Delete
            </button>

            <button
              type='button'
              className='btn-primary promoter-email__btn'
              onClick={handleConfirmInfo}
            >
              Save
            </button>
          </>
        )}
      </div>
    </section>
  )
}

const mapStateToProps = ({ auth }) => ({
  token: auth.user.token,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PromoterEmail)
);
